"use client";

import React, { useEffect } from "react";
import {
  Autocomplete as MUIAutoComplete,
  CircularProgress,
} from "@mui/material";
import { CustomFormLabel, CustomTextField } from "../formsComponents";
import { api } from "../../api/api";
import { IJobCustomer } from "../../redux/job_customer";

export interface IBillingCompanyAutoSearch {
  label?: string;
  value: IJobCustomer[];
  disabled?: boolean;
  error?: string | boolean;
  helperText?: string;
  onSelect: (value: IJobCustomer[]) => void;
}

export const BillingCompanyAutoSearch: React.FC<IBillingCompanyAutoSearch> = (
  props,
) => {
  const { value = [], onSelect, label, disabled } = props;
  const [options, setOptions] = React.useState<readonly IJobCustomer[]>([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const fetchSuggestion = async () => {
      setLoading(true);
      try {
        const url = `/customer/get-customer?pageNo=1&itemPerPage=1000`;
        const res = await api.get(url);
        const data: IJobCustomer[] = res.data.data;
        setOptions(
          data.map((item) => ({
            ...item,
            customer_uuid: item.customer_uuid ?? "",
            customer_name: item.customer_name ?? "",
          })),
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSuggestion();
  }, []);

  return (
    <>
      {label && <CustomFormLabel>{label}</CustomFormLabel>}
      <MUIAutoComplete
        multiple
        fullWidth
        sx={{
          ".MuiOutlinedInput-root": {
            paddingTop: "2px",
            paddingBottom: "2px",
            color: "rgb(38, 38, 38)",
            width: "100%",
          },
        }}
        getOptionLabel={(option) => option.customer_name || ""}
        options={options}
        // value={options.filter((opt) =>
        // 	value.some(
        // 		(val) => val.company_outlet_uuid === opt.company_outlet_uuid
        // 	)
        // )}
        value={options.filter(
          (opt) =>
            Array.isArray(value) &&
            value.some((val) => val.customer_uuid === opt.customer_uuid),
        )}
        isOptionEqualToValue={(option, value) =>
          option.customer_uuid === value.customer_uuid
        }
        loading={loading}
        disabled={disabled}
        noOptionsText="No billing companies available"
        onChange={(event, newValue) => {
          onSelect(newValue);
        }}
        renderInput={(params) => (
          <CustomTextField
            {...params}
            fullWidth
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};
